import { WIDGET_NAME } from '@sitegen/common/constants';
import { trackingFlowSubTypes } from '../constants/analytics';

export const getTrackingFlowSubType = (widgetName: WIDGET_NAME) => {
    if (widgetName === WIDGET_NAME.CF_REDEEM) {
        return trackingFlowSubTypes[widgetName];
    }

    if (widgetName === WIDGET_NAME.ULC_REDEEM) {
        return trackingFlowSubTypes[widgetName];
    }

    if (widgetName === WIDGET_NAME.PYC_REDEEM) {
        return trackingFlowSubTypes[widgetName];
    }

    return '';
};
